import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0px 8px;
`;

export const TabsArea = styled.div`
    .ant-tabs-nav {
        margin-bottom: 24px;
    }

    .ant-tabs-tab {
        font-size: 15px;
        padding: 12px 0;
    }

    .ant-tabs-tab + .ant-tabs-tab {
        margin-left: 32px;
    }

    .ant-tabs-tab-active .ant-tabs-tab-btn {
        font-weight: 700;
    }
`;

export const TabContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const Notice = styled.div`
    margin-top: 12px;
    display: flex;
    gap: 10px;
    align-items: flex-start;
    padding: 10px 14px;
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.colorPrimaryBg};
    border: 1px solid ${({ theme }) => theme.colors.colorPrimaryBorder};
    color: ${({ theme }) => theme.colors.antdText};
    line-height: 1.55;

    .anticon {
        flex-shrink: 0;
        margin-top: 4px;
        color: #1677ff;
    }
`;

export const ResultCount = styled.span`
    display: block;
    margin: 8px 0 0;
    color: ${({ theme }) => theme.colors.antdTextSecondary};
`;

export const TableArea = styled.div`
    width: 100%;
    overflow: hidden;
    border: 1px solid ${({ theme }) => theme.colors.antdBorderSecondary};
    border-radius: 8px;

    .ant-table,
    .ant-table-container {
        border: 0;
    }

    .ant-table-tbody > tr > td {
        border-bottom: 1px solid
            ${({ theme }) => theme.colors.antdBorderSecondary};
    }

    .ant-table-tbody > tr:last-child > td {
        border-bottom: 0;
    }
`;

export const RightHeader = styled.span`
    display: block;
    text-align: right;
`;

export const DueDateHeader = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;

    svg {
        color: #1677ff;
    }
`;

export const Tabular = styled.span`
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
`;

export const Money = styled(Tabular)`
    display: block;
    text-align: right;
    font-weight: 600;
`;

export const Capitalized = styled.span`
    text-transform: capitalize;
`;

export const StatusDot = styled.span<{ $color: string }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${({ $color }) => $color};
`;

export const OptionWithDot = styled.span`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const BarcodeBox = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const BarcodeText = styled.span`
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    color: ${({ theme }) => theme.colors.antdTextSecondary};
    font-variant-numeric: tabular-nums;
    cursor: default;
`;

export const ExpiredBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    line-height: 1.45;

    strong {
        font-weight: 700;
    }

    span {
        font-size: 13px;
        color: ${({ theme }) => theme.colors.antdTextSecondary};
    }
`;

export const Muted = styled.span`
    color: ${({ theme }) => theme.colors.antdTextSecondary};
`;

export const EmptyBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 24px;
    color: ${({ theme }) => theme.colors.antdTextSecondary};
`;

export const ExportCard = styled.div`
    width: 100%;
    background: ${({ theme }) => theme.colors.antdBackground};
    border: 1px solid ${({ theme }) => theme.colors.antdBorder};
    border-radius: 12px;
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 18px 24px;
    flex-wrap: wrap;
`;

export const ExportIcon = styled.div`
    width: 48px;
    height: 48px;
    border-radius: 10px;
    flex-shrink: 0;
    background: #e6f7ff;
    color: #4b7cf3;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ExportInfo = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 3px;
`;

export const ExportTitle = styled.span`
    font-size: 16px;
    font-weight: 700;
`;

export const ExportSubtitle = styled.span`
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.antdTextSecondary};
`;
